<template>
  <layout-main>
    <div class="container">
      <div class="table-container">
        <div class="loading" v-if="fetchingUsers">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </div>

        <md-table v-model="users">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            :class="{deleting: item.loginId === deleting}"
          >
            <md-table-cell style="text-align:center;">
              <user-icon :admin="item.roles.includes('admin')"/>
            </md-table-cell>
            <md-table-cell md-label="ログインID">
              <span>{{ item.loginId }}</span>
            </md-table-cell>
            <md-table-cell md-label="氏名">{{ item.name }}</md-table-cell>
            <md-table-cell md-label="所属">{{ item.organization }}</md-table-cell>
            <md-table-cell md-label="メールアドレス">{{ item.email }}</md-table-cell>
            <md-table-cell md-label="初期パスワード">{{ item.password }}</md-table-cell>
            <md-table-cell style="text-align: center;">
              <md-button class="md-icon-button md-primary" @click="editUser(item.loginId)">
                <font-awesome-icon icon="edit"/>
              </md-button>

              <md-menu md-size="big" md-direction="bottom-end">
                <md-button md-menu-trigger class="md-icon-button">
                  <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content>
                  <md-menu-item class="menu-item-header">
                    <span class="label">{{ item.loginId }}</span>
                    <span class="label">
                      <user-icon :admin="item.is_admin"/>
                    </span>
                  </md-menu-item>
                  <md-menu-item
                    @click="deleteUser(item.loginId)"
                    :disabled="item.loginId === currentloginId"
                  >
                    <span>削除</span>
                    <font-awesome-icon fixed-width icon="trash-alt"/>
                  </md-menu-item>
                  <md-menu-item @click="editUser(item.loginId)">
                    <span>編集</span>
                    <font-awesome-icon icon="edit"/>
                  </md-menu-item>
                  <md-menu-item @click="resetPassword(item.loginId)">
                    <span>パスワードリセット</span>
                    <font-awesome-icon fixed-width icon="key"/>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>

      <div v-if="contractDataTypes.includes('POS')">
        <div class="speed-dial">
          <md-button @click="addUser" class="md-fab md-raised md-accent">
            <font-awesome-icon icon="plus" />
          </md-button>
        </div>
        <div class="speed-dial-download">
          <md-speed-dial>
            <md-speed-dial-target class="md-fab md-raised md-accent">
              <font-awesome-icon icon="file-download" />
            </md-speed-dial-target>

            <md-speed-dial-content>
              <md-button @click="downloadUsersCategory" class="md-fab md-mini">
                <md-tooltip class="tooltip" md-direction="right">ユーザーのPOS閲覧可能分類一覧</md-tooltip>
                <md-icon>difference</md-icon>
              </md-button>

              <md-button @click="download" class="md-fab md-mini">
                <md-tooltip class="tooltip" md-direction="right">ユーザー一覧</md-tooltip>
                <md-icon>description</md-icon>
              </md-button>
            </md-speed-dial-content>
          </md-speed-dial>
        </div>
        <div class="speed-dial-upload">
          <md-button @click="accountUpload.showDialog = true" class="md-fab md-raised md-accent">
            <md-tooltip class="tooltip" md-direction="right">アカウント情報一括登録</md-tooltip>
            <font-awesome-icon icon="file-upload"/>
          </md-button>
        </div>
      </div>
      <div v-else>
        <div class="speed-dial">
          <md-button @click="addUser" class="md-fab md-raised md-accent">
            <font-awesome-icon icon="plus"/>
          </md-button>
          <md-button @click="download" class="md-fab md-raised md-accent">
            <font-awesome-icon icon="file-download"/>
          </md-button>
          <md-button @click="accountUpload.showDialog = true" class="md-fab md-raised md-accent">
            <md-tooltip class="tooltip" md-direction="right">アカウント情報一括登録</md-tooltip>
            <font-awesome-icon icon="file-upload"/>
          </md-button>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="accountUpload.showDialog" class="dialog-window">
      <md-dialog-title>
        <div class="file">
          <div class="file-name">
            <font-awesome-icon
              class="icon icon-with-text"
              icon="file-alt"
            >
            </font-awesome-icon>
            <a href="#" @click.prevent="$refs.file.click()">
              {{ accountUploadFileName }}
            </a>
          </div>
          <input
            hidden
            ref="file"
            type="file"
            accept=".tsv, .txt"
            multiple
            @change="setUploadAccountFiles($event.target.files)"
            :disabled="accountUpload.showProgressDialog"
          />
        </div>
      </md-dialog-title>

      <md-dialog-actions>
        <div>
          <md-tooltip class="tooltip" md-direction="top">サンプルファイルはこちらからダウンロードできます</md-tooltip>
          <gl-button @click="moveToHelp">
            <span>操作マニュアル</span>
            <md-icon>help</md-icon>
          </gl-button>
        </div>
        <gl-button
          @click="accountUpload.showDialog = false"
          :disabled="accountUpload.showProgressDialog"
        >
          キャンセル
        </gl-button>
        <gl-button
          class="md-primary"
          @click="uploadAccountFile"
          :disabled="this.accountUpload.file === undefined || this.accountUpload.showProgressDialog"
        >
          アップロード
        </gl-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="accountUpload.showProgressDialog"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content>
        <div style="display:flex;align-items:center">
          <spinner :diameter="30" />
          <span style="margin-left:var(--spacing-medium)">
            アカウントファイルを{{ accountUpload.progressDialogMessage }}しています...
          </span>
        </div>
      </md-dialog-content>
    </md-dialog>


    <md-dialog :md-active.sync="accountUpload.showResultDialog" class="dialog-window">
      <md-dialog-title>ファイル取り込み結果
      </md-dialog-title>
      
      <md-dialog-content>
        <div class="account-result-container">
          <md-table v-model="accountUpload.resultMessages">
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
            >
              <md-table-cell class="row-index" md-label="行数" :class="accountUploadResultClasses(item.status)">{{ item.rowIndex }}</md-table-cell>
              <md-table-cell class="message" md-label="結果">{{ item.message }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="accountUpload.showResultDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

  </layout-main>
</template>

<script>
import LayoutMain from '@/components/layout/LayoutMain'
import { filter } from 'rxjs/operators'
import UserIcon from '@/components/UserIcon.vue'
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue'
import download from '@/util/download'
import Spinner from '@/components/Spinner.vue'

function escapeCsvString(value) {
  if (!value) {
    return value
  }
  if (typeof value !== 'string') {
    return value
  }
  return `"${value.replaceAll('"', '""')}"`
}

export default {
  components: { LayoutMain, UserIcon, Spinner },
  name: 'Users',
  data() {
    return {
      fetchingUsers: true,
      users: [],
      currentloginId: this.$store.state.user.loginId,
      deleting: undefined,
      contractDataTypes: [],
      accountUpload: {
        file: undefined,
        showDialog: false,
        showProgressDialog: false,
        showResultDialog: false,
        resultMessages: [],
        progressDialogMessage: '',
      },
    }
  },
  methods: {
    editUser(loginId) {
      this.$router.push({ name: 'user_edit', params: { loginId } })
    },
    addUser() {
      this.$router.push({ path: 'user' })
    },
    async download() {
      let csv =
        [
          'ログインID',
          '氏名',
          '所属',
          'メールアドレス',
          '権限',
          '利用サービス',
          '契約開始日',
          '契約終了日',
          '備考',
          'ホールディングス',
        ].join(',') + '\n'
      const columns = [
        'loginId',
        'name',
        'organization',
        'email',
        'roles',
        'services',
        'validThrough',
        'note',
        'companies',
      ]
      const roles = await this.$role.getRoles()
      const services = await this.$service.getServices()

      //データ
      this.users.forEach(user => {
        let arr = []
        columns.forEach(column => {
          if (column === 'roles') {
            const role = roles.find(r => r.code === user.roles[0])
            arr.push(role.name)
          } else if (column === 'services') {
            let serviceArr = []
            user.services.forEach(us => {
              const service = services.find(s => s.serviceCode === us)
              if (service) {
                serviceArr.push(service.serviceName)
              }
            })
            arr.push(serviceArr.join('・'))
          } else if (column === 'validThrough') {
            arr.push(user[column][0], user[column][1])
          } else if (column === 'companies') {
            arr.push(user[column] === null)
          } else {
            arr.push(user[column])
          }
        })
        csv += arr.map(escapeCsvString).join(',')
        csv += '\n'
      })

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]) //BOM
      const blob = new Blob([bom, csv], { type: 'text/csv' })

      download(blob, 'users.csv')
    },
    async downloadUsersCategory() {
      let csv =
        [
          'ログインID',
          '氏名',
          '契約形態',
          '階層名',
          'カテゴリーコード',
          'カテゴリ名',
        ].join(',') + '\n'
      const columns = [
        'loginId',
        'name',
        'posRestrictToInhouse',
        'categoryLevelName',
        'categoryCode',
        'categoryName',
      ]

      const usersCategory = await this.$account.getUsersCategory(
        this.$store.state.user.companyCode,
      )
      //データ
      usersCategory.forEach(user => {
        let arr = []
        columns.forEach(column => {
          if (column === 'posRestrictToInhouse') {
            if (user.posRestrictToInhouse) {
              arr.push('自社商品')
            } else {
              arr.push('全商品')
            }
          } else {
            arr.push(user[column])
          }
        })
        csv += arr.map(escapeCsvString).join(',')
        csv += '\n'
      })

      const bom = new Uint8Array([0xef, 0xbb, 0xbf]) //BOM
      const blob = new Blob([bom, csv], { type: 'text/csv' })

      download(blob, 'user-category.csv')
    },
    async deleteUser(loginId) {
      this.$dialog
        .open(ConfirmationDialog, {
          message: `「${loginId}」を削除します。`,
          buttonTextOk: '削除する',
        })
        .pipe(filter(response => response))
        .subscribe(async () => {
          this.deleting = loginId
          await this.$account.deleteAccount(
            this.$store.state.user.companyCode,
            loginId,
          )
          this.users = await this.$account.getAccounts(
            this.$store.state.user.companyCode,
          )
        })
    },
    async resetPassword(loginId) {
      this.$dialog
        .open(ConfirmationDialog, {
          message: `「${loginId}」のパスワードをリセットします。`,
          buttonTextOk: 'リセットする',
        })
        .pipe(filter(response => response))
        .subscribe(async () => {
          await this.$account.resetPassword(
            this.$store.state.user.companyCode,
            loginId,
          )
          this.users = await this.$account.getAccounts(
            this.$store.state.user.companyCode,
          )
        })
    },
    async setUploadAccountFiles(files) {
      if (files.length === 0) {
        return
      }
      this.accountUpload.file = files[0]
    },
    async uploadAccountFile() {
      this.accountUpload.showDialog = false
      this.accountUpload.resultMessages = []
      this.accountUpload.progressDialogMessage = 'アップロード・読み込み'
      this.accountUpload.showProgressDialog = true

      const loadResults = await this.$account.upload(
        this.$store.state.user.companyCode,
        this.accountUpload.file,
      )

      this.accountUpload.progressDialogMessage = '登録・更新'

      let messages = []
      for (const loadResult of loadResults) {
        if (loadResult.errors.length) {
          // エラーが含まれる場合
          // errorsはオブジェクトのリストで、rowNumとmessageを持つ
          const groupedObj = loadResult.errors.reduce((acc, curr) => {
            // まだその行番号のキーが無ければそのままメッセージを入れる。
            if (!acc[curr.rowNum]) {
              acc[curr.rowNum] = curr.message
            } else {
              // すでにその行番号のキーがあれば、改行を入れてメッセージを追加する。
              acc[curr.rowNum] += '\n' + curr.message
            }
            return acc
          }, {})
          // groupedObjは、rowNumをキー、messageを値とするオブジェクトになる。
          Object.entries(groupedObj).forEach(([rowNum, message]) => {
            messages.push({
              rowIndex: Number(rowNum),
              message: message,
              status: 'error',
            })
          })
        } else {
          if (loadResult.mode === 'add') {
            // 追加
            const err = await this.$account.addAccount(
              this.$store.state.user.companyCode,
              loadResult.account,
            )
            if (err) {
              // 登録エラー
              messages.push({
                rowIndex: loadResult.rowIndex,
                message: err.message,
                status: 'error',
              })
            } else {
              messages.push({
                rowIndex: loadResult.rowIndex,
                message: '追加しました',
                status: 'ok',
              })
            }
          } else {
            // 更新
            const err = await this.$account.updateAccount(
              this.$store.state.user.companyCode,
              loadResult.account.loginId,
              loadResult.account,
            )
            if (err) {
              messages.push({
                rowIndex: loadResult.rowIndex,
                message: err.message,
                status: 'error',
              })
            } else {
              messages.push({
                rowIndex: loadResult.rowIndex,
                message: '更新しました',
                status: 'ok',
              })
            }
          }

          // Mouse登録処理
          if (messages.at(-1).status === 'ok' && loadResult.mouse) {
            //追加されたユーザIDを取得する
            const user = await this.$account.getAccount(
              this.$store.state.user.companyCode,
              loadResult.account.loginId,
            )
            loadResult.mouse = loadResult.mouse.map(m => {
              return {
                ...m,
                userId: user.userId,
              }
            })

            // 追加・更新
            const mouseErr = await this.$mouseAccount.add(loadResult.mouse)
            if (mouseErr) {
              messages.at(-1).message = 'Mouse:' + mouseErr.message
              messages.at(-1).status = 'ng'
            }
          }
        }
      }

      this.accountUpload.showProgressDialog = false
      this.accountUpload.file = undefined
      this.accountUpload.resultMessages = messages.sort(
        (a, b) => a.rowIndex - b.rowIndex,
      )
      this.accountUpload.showResultDialog = true

      // リロード
      this.users = await this.$account.getAccounts(
        this.$store.state.user.companyCode,
      )
    },
    accountUploadResultClasses(status) {
      if (status === 'ok') {
        return 'account-result-ok'
      } else {
        return 'account-result-error'
      }
    },
    moveToHelp() {
      window.open(
        `${process.env.VUE_APP_HELP_SITE_URL_BASE}ユーザー管理_一括登録.html`,
      )
    },
  },
  async mounted() {
    this.users = await this.$account.getAccounts(
      this.$store.state.user.companyCode,
    )
    this.fetchingUsers = false
    const site = await this.$site.getSite()
    this.contractDataTypes = site.contractDataTypes
  },
  computed: {
    accountUploadFileName() {
      return this.accountUpload.file
        ? this.accountUpload.file.name
        : 'ファイルを選択してください'
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
}

.table-container {
  width: 100%;
}

.loading {
  display: flex;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
}

.speed-dial {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 100;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
}

.speed-dial-download {
  position: fixed;
  bottom: 25px;
  left: 95px;
  z-index: 100;
  opacity: 0.8;
}

.speed-dial-upload {
  position: fixed;
  bottom: 20px;
  left: 160px;
  z-index: 100;
  opacity: 0.8;
}

.deleting {
  opacity: 0.6;
  pointer-events: none;
}

.menu-item-header {
  .label {
    color: #546e7a;
  }
}

.tooltip {
  padding: 5px 10px;
  font-size: 20px;
  width: auto;
  height: 30px;
}
.account-result-container {
  position: relative;
  height: 400px;
  width: 800px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: 5px;
  white-space: pre;
}
.account-result-ok {
  background-color: #26a69a;
  color: var(--text-color-accent);
}
.account-result-error {
  background-color: var(--color-warn);
  color: var(--text-color-accent);
}
</style>
